import { render, staticRenderFns } from "./WarnRecordItem.vue?vue&type=template&id=611df655&scoped=true"
import script from "./WarnRecordItem.vue?vue&type=script&lang=js"
export * from "./WarnRecordItem.vue?vue&type=script&lang=js"
import style0 from "./WarnRecordItem.vue?vue&type=style&index=0&id=611df655&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611df655",
  null
  
)

export default component.exports